/**
 * These helper function must be deprecated as color will be defined inside design system.
 * Undefined colors are edge case that we want to avoir to preserve consistency accross UI.
 * We keep them available but deprecated for future update & backward compatibility.
 */
import Color from "color";

/**
 * @deprecated
 */
export const darken = (color: string, amount: number) => String(Color(color).darken(amount));

/**
 * @deprecated
 */
export const lighten = (color: string, amount: number) => String(Color(color).lighten(amount));

/**
 * @deprecated
 */
export const fade = (color: string, amount: number) => String(Color(color).fade(amount));

// NOTE: Color Modifier not used
/**
 * @deprecated
 */
export const opaquer = (color: string, amount: number) => String(Color(color).opaquer(amount));

// NOTE: Color Modifier not used
/**
 * @deprecated
 */
export const isDarkColor = (color: string) => new Color(color).isDark();
